import React, { useState } from "react";
import config from "../utils/Config";
import Header from "./layouts/NavBar";
import Footer from "./layouts/Footer";

const EVENTOS = [
  { value: '', label: 'Todos' },
  { value: 'EVT.RES.ALERT_CREATE', label: 'Crear alerta' },
  { value: 'EVT.RES.ROOM_UNASSIGN', label: 'Desasignar habitación' },
  { value: 'EVT.RES.CHECKIN', label: 'Check-in de reserva' },
  { value: 'EVT.RES.ROOM_ASSIGN', label: 'Asignar número de habitación' },
  { value: 'EVT.CUST.PROFILE_UPDATE', label: 'Actualización de datos de huésped/reserva' },
  { value: 'EVT.RES.GET_BY_CONFIRMATION', label: 'Recuperar por N° confirmación' }
  ];

const Auditoria = () => {
  const [username, setUsername] = useState("");
  const [fechaDesde, setFechaDesde] = useState("");
  const [fechaHasta, setFechaHasta] = useState("");
  const [resultados, setResultados] = useState([]);
  const [error, setError] = useState("");

  const buscarAuditoria = async () => {
    const token = localStorage.getItem("authToken");

    if (!token) {
      setError("No se encontró el token de autenticación.");
      return;
    }

    const filtros = {
      username: username || null,
      fechaDesde: fechaDesde || null,
      fechaHasta: fechaHasta || null,
      Evento: evento || null
    };

    try {
      const response = await fetch(`${config.baseUrl}/Cuentas/ReporteAuditoria`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(filtros),
      });

      if (!response.ok) {
        throw new Error(`Error ${response.status}`);
      }

      const data = await response.json();
      if (data.length === 0) {
        setError("No se encontraron registros.");
      } else {
        setError("");
      }
      setResultados(data);
    } catch (err) {
      console.error("Error al buscar auditoría:", err);
      setError("No se pudieron obtener los datos de auditoría.");
    }

  };

  const [evento, setEvento] = useState('');

  return (
    <>
      <Header />
      <div className="container mt-4">
        <h3 className="mb-3">Reporte de Auditoría</h3>

        {error && <div className="alert alert-info">{error}</div>}

        <div className="card p-3 mb-4">
          <div className="row g-3">
            <div className="col-md-4">
              <label className="form-label">Usuario</label>
              <input
                type="text"
                className="form-control"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                placeholder="Ingrese username"
              />
            </div>
            <div className="col-md-3">
              <label className="form-label">Fecha Desde</label>
              <input
                type="date"
                className="form-control"
                value={fechaDesde}
                onChange={(e) => setFechaDesde(e.target.value)}
              />
            </div>
            <div className="col-md-3">
              <label className="form-label">Fecha Hasta</label>
              <input
                type="date"
                className="form-control"
                value={fechaHasta}
                onChange={(e) => setFechaHasta(e.target.value)}
              />
            </div>

            <div className="col-md-3"> 
              <label className="form-label">Evento</label> 
              <select className="form-select" value={evento} 
                onChange={(e) => setEvento(e.target.value)} > 
                {EVENTOS.map(opt => ( <option key={opt.value} 
                value={opt.value}>{opt.label}</option> ))} 
              </select> 
            </div>

            <div className="col-md-2 d-flex align-items-end">
              <button onClick={buscarAuditoria} className="btn btn-primary w-100">
                Buscar
              </button>
            </div>
          </div>
        </div>

        {resultados.length > 0 && (
          <div className="table-responsive">
            <table className="table table-bordered">
              <thead className="table-light">
                <tr>
                  <th>Fecha</th>
                  <th>N° Confirmación</th>
                  <th>Usuario</th>
                  <th>Acción</th>
                </tr>
              </thead>
              <tbody>
                {resultados.map((registro, index) => (
                  <tr key={index}>
                    <td>{registro.fechaHora}</td>
                    <td>{registro.nroConfirmacion}</td>
                    <td>{registro.usuario}</td>
                    <td>{registro.accion}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
      <Footer />
    </>
  );
};

export default Auditoria;
